export default __webpack_public_path__ + "static/media/calender.559d4a5e.png";